import React from 'react'
import styled, { ThemeProvider } from 'styled-components'
import {lightTheme} from './Themes';
import { Develope} from './AllSvgs';


import LogoComponent from '../subComponents/LogoComponent';
import SocialIcons from '../subComponents/SocialIcons';
import ParticleComponent from '../subComponents/ParticleComponent';
import BigTitle from '../subComponents/BigTitlte'


const Box = styled.div`
background-color: ${props => props.theme.body};
width: 100vw;
height:100vh;
position: relative;
display: flex;
justify-content: space-evenly;
align-items: center;


`

const Main = styled.div`
border: 2px solid ${props => props.theme.text};
color: ${props => props.theme.text};
background-color: ${props => props.theme.body};
padding: 2rem;
width: 70vw;
height: 70vh;
z-index:3;
line-height: 1.5;
cursor: pointer;

font-family: 'Ubuntu Mono',monospace;
display: flex;
flex-direction: column;
justify-content: space-between;

&:hover{
    color: ${props => props.theme.body};
    background-color: ${props => props.theme.text};
}
`

const Title = styled.h2`
display: flex;
justify-content: center;
align-items: center;
font-size: calc(1em + 1vw);

${Main}:hover &{
    &>*{
        fill:${props => props.theme.body};
    }
}

&>*:first-child{
margin-right: 1rem;
}
`

const Description = styled.div`
color: ${props => props.theme.text};
font-size: calc(0.6em + 1vw);
padding: 0.5rem 0;


${Main}:hover &{
   
        color:${props => props.theme.body};
    
}

strong{
    text-transform: uppercase;
}
ul,p{
    margin-left: 2rem;
}
`

const MySkillsPage = () => {
    return (
        <ThemeProvider theme={lightTheme}>
        <Box>

        <LogoComponent theme='light'/>
        <SocialIcons theme='light'/>
        <ParticleComponent theme='light' />
        <Main>
            <Title>
                <Develope width={40} height={40} /> Software Engineer - .Net Developer
            </Title>
            <Description>
                Choosing the best architecture of the software and Keeping it clean, minimal and simple is an ultimate goal, I value the business or brand for which I'm creating, thus I enjoy bringing new ideas to life.
            </Description>
            <Description>
                    <p>
                        <strong>Languages</strong> : C#, Python, JavaScript, HTML, CSS.
                    </p>
            </Description>
            <Description>
                    <p>
                        <strong>Tools</strong> : Visual Studio, VScode, Github, Microsoft SQL Server, MySQL, Wordpress, Adobe XD.
                    </p>
            </Description>

            <Description>
                    <p>
                    <strong>Frameworks</strong> : ASP.Net MVC Core, .Net Core, React, JQuery, LINQ, Bootstrap. 
                    </p>
            </Description>
            <Description>
                    <p>
                    <strong>Database & ORM</strong> : SQLite, MySQL, Microsoft SQL, EntityFrameWork Core.
                    </p>
            </Description>
            <Description>
                    <p>
                    <strong>Version Control</strong> : Git.
                    </p>
            </Description>

        </Main>
            <BigTitle text="SKILLS" top="80%" right="30%" />

        </Box>

        </ThemeProvider>
        
    )
}

export default MySkillsPage
